<template>
<div class="MMyFavorite">
    <van-tabs sticky v-model="active" animated line-height="2" line-width="25" color="#409EFF" title-inactive-color="#333" title-active-color="#409EFF">
        <van-tab title="课程">
            <CourseList></CourseList>
        </van-tab>
        <van-tab title="题库">
            <QuestionList></QuestionList>
        </van-tab>
        <van-tab title="报告">
            <ReportList></ReportList>
        </van-tab>
        <van-tab title="活动">
            <ActiveList></ActiveList>
        </van-tab>
    </van-tabs>
</div>
</template>

<script>
import CourseList from 'views/mobile/my/favorite/components/CourseList'
import QuestionList from 'views/mobile/my/favorite/components/QuestionList'
import ReportList from 'views/mobile/my/favorite/components/ReportList'
import ActiveList from 'views/mobile/my/favorite/components/ActiveList'
import {mapActions} from 'vuex'
export default {
    name: 'MMyFavorite',
    data() {
        return {
            active: 0,
        }
    },
    mounted() {
        document.title = '我的收藏'
    },
    activated() {},
    methods: {
        ...mapActions([
            'setNoDataTip'
        ])
    },
    filters: {},
    watch: {
        'active': {
            handler(newV) {
                if (newV === 0) {
                    this.setNoDataTip('当前还没有收藏课程，快去学习收藏吧！')
                } else if (newV === 1) {
                    this.setNoDataTip('当前还没有收藏题库，快去学习收藏吧！')
                } else if (newV === 2) {
                    this.setNoDataTip('当前还没有收藏报告，快去学习收藏吧！')
                } else if (newV === 3) {
                    this.setNoDataTip('当前还没有收藏活动，快去学习收藏吧！')
                }
            }
        }
    },
    computed: {},
    components: {
        CourseList,
        QuestionList,
        ReportList,
        ActiveList
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
// @import "~common/scss/variable";
.MMyFavorite {
    .van-tabs__wrap {
        border-bottom: 0.01rem solid #E5E5E5;
    }
    .van-tabs__nav--line {
        padding-bottom: 0.16rem;
    }
}
</style>